module.exports = __webpack_public_path__ + "static/media/postgres.1b74cc9c.png";